import React from 'react';

import useActivateFCM from './useActivateFCM';
import useMessageHandler from './useMessageHandler';

type Props = {
  children: React.ReactNode;
  isHeadless?: boolean;
};

const Component: React.FC<Props> = ({ children, isHeadless }) => {
  useActivateFCM();
  useMessageHandler();

  if (isHeadless) {
    // App has been launched in the background by iOS, ignore
    return null;
  }

  return <>{children}</>;
};

Component.displayName = 'Firebase';

export default Component;
